<!--
  template(if) - list(show) 구조는 불필요한 로드를 방지하기 위해서임.
  refresh 는 add, detail 성공시 호출해야 함.
-->

<template>
  <div class="animated fadeIn">
    <template v-if="base">
    <List v-show="list" ref="list" />
    </template>
    <Edit v-if="detail" @refresh="refresh" />
  </div>
</template>

<script>
import List from './Report.List';
import Edit from './Report.Edit';

export default {
  components: { List, Edit},
  data: () => ({ base: false, list: false, detail: false, detail: false }),
  methods: {
    refresh() { if(this.$refs.list) { this.$refs.list.refresh(); } },
    select({ id, tag }) {
      if(!id) { this.base = this.list = !(this.detail = this.detail = false); }
      else if(id === 'add' || tag === 'detail') { this.detail = !(this.detail = this.list = false); }
      else { this.detail = !(this.list = this.detail = false); }
    }
  },
  created: function() { console.log('Report.vue', 'created'); },
  destroyed: function() { console.log('Report.vue', 'destroyed'); },
  mounted: function() {
    console.log('Report.vue', 'mounted');
    this.select(this.$route.params);
  },
  watch: {
    '$route' (to, from) {
      console.log('Report.vue', 'route changed', to.param);
      this.select(to.params);
    }
  },
}
</script>
